export const WEBLATE_COMPONENT_NAME = 'website-pro/wsp-portal-client';
